/** Square image variant names used by Avatar and listing-card API queries. */
export const AVATAR_IMAGE_VARIANTS = [
  'square-xsmall',
  'square-xsmall2x',
  'square-small',
  'square-small2x',
];

/** Sharetribe `fields.image` entries for author avatars on listing cards. */
export const avatarImageFieldVariants = AVATAR_IMAGE_VARIANTS.map(v => `variants.${v}`);

/** User fields needed by ListingCard author row (name, forum avatar, review aggregate). */
export const listingCardAuthorUserFields = [
  'profile.displayName',
  'profile.abbreviatedName',
  'profile.publicData.xfAvatarUrl',
  'profile.metadata.reviewAverage',
  'profile.metadata.reviewCount',
];

/** User fields needed by InboxPage transaction counterpart avatars. */
export const inboxParticipantUserFields = [
  'profile.displayName',
  'profile.abbreviatedName',
  'profile.publicData.xfAvatarUrl',
  'deleted',
  'banned',
];

/** User fields needed by ListingPage seller line (ratings, sales, Community Sponsor, XenForo DM). */
export const listingPageAuthorUserFields = [
  ...listingCardAuthorUserFields,
  'profile.metadata.itemsSoldCount',
  'profile.metadata.verifiedUserType',
  'profile.publicData.userType',
  'profile.publicData.xfUsername',
  'profile.publicData.freeShippingLiveEnabled',
  'profile.publicData.freeShippingLiveThresholdSubunits',
  'profile.publicData.freeShippingDryEnabled',
  'profile.publicData.freeShippingDryThresholdSubunits',
];

/** publicData fields needed by ListingCard sponsor highlight styling. */
export const listingCardSponsorHighlightFields = [
  'publicData.sponsorHighlight',
  'publicData.authorUserType',
];
